export default "__VITE_ASSET__DJjm1vio__"